import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { ScrollText, Loader2, RefreshCw } from "lucide-react";

const badge = (s) => {
  const map = { ok: "bg-emerald-100 text-emerald-700", fail: "bg-rose-100 text-rose-700", warn: "bg-amber-100 text-amber-700", mfa: "bg-sky-100 text-sky-700" };
  return map[s] || "bg-slate-100 text-slate-600";
};

export function ActivityLog() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/admin/audit?limit=100");
      setRows(data);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="bg-white border border-slate-200 rounded-xl mt-6 overflow-hidden" data-testid="admin-activity-log">
      <div className="flex items-center gap-2 px-5 py-3.5 border-b border-slate-200 bg-slate-50">
        <ScrollText className="w-4 h-4 text-slate-500" />
        <span className="text-sm font-semibold text-slate-700">Activity log</span>
        <span className="text-xs text-slate-400">— admin sign-ins, MFA changes & privileged edits</span>
        <button onClick={load} className="ml-auto text-slate-400 hover:text-primary" title="Refresh" data-testid="audit-refresh">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
        </button>
      </div>
      {rows === null ? (
        <div className="p-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-primary" /></div>
      ) : rows.length === 0 ? (
        <div className="p-10 text-center text-slate-400 text-sm">No activity recorded yet.</div>
      ) : (
        <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-white sticky top-0">
              <tr className="text-left text-slate-500 border-b border-slate-100">
                <th className="px-5 py-2 font-semibold">When (UTC)</th>
                <th className="px-3 py-2 font-semibold">Who</th>
                <th className="px-3 py-2 font-semibold">Action</th>
                <th className="px-3 py-2 font-semibold">Detail</th>
                <th className="px-3 py-2 font-semibold">Status</th>
                <th className="px-3 py-2 font-semibold">IP</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-slate-50 hover:bg-slate-50" data-testid={`audit-row-${i}`}>
                  <td className="px-5 py-2 font-num text-xs text-slate-500 whitespace-nowrap">{String(r.ts).slice(0, 19).replace("T", " ")}</td>
                  <td className="px-3 py-2 text-slate-700 whitespace-nowrap">{r.actor}</td>
                  <td className="px-3 py-2 font-num text-xs text-slate-700 whitespace-nowrap">{r.action}</td>
                  <td className="px-3 py-2 text-slate-500">{r.detail}</td>
                  <td className="px-3 py-2"><span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ${badge(r.status)}`}>{r.status}</span></td>
                  <td className="px-3 py-2 font-num text-xs text-slate-400 whitespace-nowrap">{r.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
